export const piechartsRowsCount = 2;

export const mainChartPointerRadius = 4;
export const mainChartSize = 82 + mainChartPointerRadius;

export const averageChartProgressLineSize = 2;
export const averageChartSize = 64 + averageChartProgressLineSize;
